import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native'
import { StyleSheet } from 'react-native'
import { IconInvoicePrompt } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import Wrapper from '../../Wrapper'
import { BtText } from '@linqpal/components/src/ui'
import { Spacer } from '../../../../ui/atoms'
import Loading from '../../../Loading'
import LocalStorage from '../../../../store/LocalStorage'
import { dictionaries, routes } from '@linqpal/models'
import RootStore from '../../../../store/RootStore'
import { ApplyBTCreditItem } from '../../../../ui/molecules/ApplyBTCreditItem'
import { LoanAppDetails, PaymentMethod } from './InvoiceDetails'
import {
  AddNewButton,
  AddPaymentMethodItems,
} from '../../../../ui/add-payment-method-components'
import { useInvoiceDetailsContext } from '../../TabInvoice/InvoiceDetailsContext'
import { Link } from '../../../../ui/atoms/Link'
import { WhatIsBTModal } from '../WhatIsBTModal'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import { InvoicePaymentStatusModal } from '../../../../ui/organisms/InvoicePaymentStatusModal'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { InvoiceAlert } from '../InvoiceAlert'
import { ConfirmPrompt } from '../../../../ui/molecules/ConfirmPrompt'
import { ReasonModal } from '../DismissReasonModal'
import CompanyHeader from './CompanyHeader'
import { styles as SharedStyles } from './styles'
import BuilderInvoiceSignup from '../BuilderInvoiceSignup'
import { observer } from 'mobx-react'
import { useInvoicesToPay } from '../../../../store/ScreensStore/InvoicesToPayStore'
import AddPaymentMethodStore from '../../../../store/AddPaymentMethodStore'
import { PayInvoiceModal } from '../PayInvoice/PayInvoiceModal'
import {
  AddProjectSuccessModal,
  PaymentProcessingAlert,
  UploadedInvoicePaymentSuccessAlert,
} from './modals'
import {
  AddPaymentMethodOptions,
  EligibleForACHdiscount,
  GroupedInvoicesHeader,
  OrDivider,
  PaymentMethodItem,
} from './components'
import { GroupedInvoiceList } from './GroupedInvoiceList'
import { toJS } from 'mobx'
import { GroupedInvoicesProjectWarning } from '../GroupedInvoicesProjectWarning'
import { SelectPurchaseType } from '../SelectPurchaseType'
import { ConnectBank as ConnectCreditApplicationBankWithPlaid } from '../ConnectBankWithPlaid/ConnectBank'
import ApplicationStore from '../../../GeneralApplication/Application/ApplicationStore'
import { getSnapshot } from 'mobx-state-tree'
import {
  APPROVED_STATUSES,
  LOAN_APPLICATION_STATUS,
  LoanApplicationStatuses,
  PROCESSING_STATUSES,
} from '@linqpal/models/src/dictionaries'
import useIsMobile from '../../PayablesTab/hooks/useIsMobile'
import { InvoiceCreditPaymentFlow } from '../../InvoicePayment/Credit/InvoiceCreditPaymentFlow'

export default observer(function CompanyInvoicesPay() {
  const navigation = useNavigation()
  const route = useRoute()
  const isMobile = useIsMobile()
  const {
    screensStore: { paymentMethodsStore },
  } = RootStore
  const [company, setCompany] = useState<any | null>(null)
  const [info, setInfo] = useState<any>(null)
  const [loanAppDetails, setLoanAppDetails] = useState<LoanAppDetails>({
    status: '',
    currentInvoiceCreditStatus: '',
  })
  const [btcredit, setBtcredit] = useState(false)
  const [cardPaymentAvailable, setCardPaymentAvailable] = useState(false)
  const [acceptAchPayment, setAcceptAchPayment] = useState(false)
  const [loading, setLoading] = useState(false)
  const [fullInvoiceInfoLoading, setFullInvoiceInfoLoading] = useState(false)
  const [whatIsModal, setWhatIsModal] = useState(false)
  const [showInvoiceAlert, setShowInvoiceAlert] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [reasonModal, setReasonModal] = useState(false)
  const [isFactoring, setIsFactoring] = useState<boolean | null>(null)
  const [initSelectedInvoices, setInitSelectedInvoices] = useState<any[]>([])
  const {
    selectedToPay: invoices,
    onSelect,
    achDiscountEligibility,
    totalACHDiscount,
    totalInvoiceAmount,
    calculateTotals,
    setSelectedToPay,
    selectedInvoices,
    setSelectedInvoices,
  } = useInvoicesToPay()
  const minBnplAmount =
    RootStore.remoteConfig.get('de_min_approval_amount') || 1000
  const { t } = useTranslation('global')
  const exists = company?.customer?.existingCustomer
  const {
    payInvoiceModal,
    setPayInvoiceModal,
    invoicePaymentMethod,
    setInvoicePaymentMethod,
  } = useInvoiceDetailsContext()
  const { setModal, showAddPaymentMethod } = AddPaymentMethodStore
  const invoicesPlainArray = useMemo(() => toJS(invoices), [invoices])

  const incomeSelectedInvoices = useMemo(() => {
    return invoicesPlainArray
      ? invoicesPlainArray.filter((i) => i.selected)
      : []
  }, [invoicesPlainArray])

  const invoiceIds = useMemo(
    () => incomeSelectedInvoices.map((i) => i._id),
    [incomeSelectedInvoices],
  )

  useEffect(() => {
    const fetchData = async () => {
      const storedData = await LocalStorage.get('companyInvoices')

      if (storedData && incomeSelectedInvoices[0]?.company) {
        setInitSelectedInvoices(incomeSelectedInvoices)
        setSelectedToPay(incomeSelectedInvoices)
        setSelectedInvoices(incomeSelectedInvoices)
        setCompany({ ...storedData.company, customer: storedData.customer })
        calculateTotals(incomeSelectedInvoices)
      } else {
        try {
          setFullInvoiceInfoLoading(true)
          const response = await routes.invoices.companyInvoices(
            '',
            incomeSelectedInvoices[0].supplierId || '',
            invoiceIds,
          )

          if (response?.invoices?.length) {
            const fetchedInvoices = response.invoices.map((invoice: any) => ({
              ...invoice,
              selected: true,
            }))
            const fetchedCustomer = {
              ...response.customer,
              invoiceId: fetchedInvoices[0]?._id,
            }
            const fetchedCompany = fetchedInvoices[0].company
            setInitSelectedInvoices(fetchedInvoices)
            setSelectedToPay(fetchedInvoices)
            setSelectedInvoices(fetchedInvoices)

            await LocalStorage.set('companyInvoices', {
              company: fetchedCompany,
              customer: fetchedCustomer,
            })

            setCompany({
              ...fetchedCompany,
              customer: fetchedCustomer,
            })
            calculateTotals(fetchedInvoices)
          }
        } catch (error) {
          console.error('Error fetching company invoices:', error)
        } finally {
          setFullInvoiceInfoLoading(false)
        }
      }
    }

    fetchData()
  }, [calculateTotals, invoiceIds, incomeSelectedInvoices, setSelectedToPay, setSelectedInvoices])

  useEffect(() => {
    if (selectedInvoices[0]?._id && totalInvoiceAmount) {
      ApplicationStore.getPaymentPlans(
        selectedInvoices[0]._id,
        totalInvoiceAmount,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalInvoiceAmount])

  useFocusEffect(
    useCallback(() => {
      let active = true
      let req

      if (company && initSelectedInvoices.length > 0) {
        const invIds = initSelectedInvoices
          .filter((i) => i.selected)
          .map((i) => i._id)
        if (invIds.length > 0) {
          req = routes.invoices.paymentInfo(company._id, invIds)
          req
            .then((res) => {
              if (active) {
                setInfo(res)
                setCardPaymentAvailable(res.cardPaymentAvailable)
                setLoanAppDetails({
                  status:
                    res?.loanApplicationStatus ||
                    dictionaries.LOAN_APPLICATION_STATUS.NEW,
                })

                paymentMethodsStore.fetchPaymentMethods()

                const supplierAcceptsAchPayments =
                  company?.settings?.acceptAchPayment ?? false

                const acceptCustomerAchPayment =
                  initSelectedInvoices[0].customer?.settings
                    ?.acceptAchPayment ?? true

                const isArAdvanceEnabled =
                  company?.settings?.arAdvance?.isEnabled ?? false

                const isIhcEnabled =
                  initSelectedInvoices.some(
                    (invoice) =>
                      invoice.customer?.settings?.inHouseCredit?.isEnabled ===
                      true,
                  ) ?? false

                setAcceptAchPayment(
                  supplierAcceptsAchPayments && acceptCustomerAchPayment,
                )
                setIsFactoring(isArAdvanceEnabled && isIhcEnabled)
              }
            })
            .catch(console.log)
        }
      }
      return () => {
        active = false
        req?.cancel?.()
      }
    }, [company, initSelectedInvoices, paymentMethodsStore]),
  )

  const isInvoiceEligible = useMemo(() => {
    return (
      info?.bnplPaymentAvailable &&
      info?.loanApplicationStatus !== LOAN_APPLICATION_STATUS.REJECTED &&
      info?.currentInvoiceCreditStatus !== LOAN_APPLICATION_STATUS.REJECTED
    )
  }, [
    info?.bnplPaymentAvailable,
    info?.loanApplicationStatus,
    info?.currentInvoiceCreditStatus,
  ])

  const areRegularPaymentsDisabled = useMemo(() => {
    return !!company?.isInvited
  }, [company?.isInvited])

  const isBTCreditDisabled = useMemo(() => {
    const status = loanAppDetails.currentInvoiceCreditStatus

    if (status === undefined) return false
    return (
      PROCESSING_STATUSES.includes(status as LoanApplicationStatuses) ||
      APPROVED_STATUSES.includes(status as LoanApplicationStatuses)
    )
  }, [loanAppDetails.currentInvoiceCreditStatus])

  const getBankAccounts = useCallback(() => {
    paymentMethodsStore.fetchPaymentMethods()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onPaymentSelection = useCallback(
    (method) => {
      if (method.paymentMethodType === 'card' && !cardPaymentAvailable) {
        setShowInvoiceAlert(true)
      } else {
        setInvoicePaymentMethod(getSnapshot(method))
        setPayInvoiceModal(true)
      }
    },
    [cardPaymentAvailable, setPayInvoiceModal, setInvoicePaymentMethod],
  )

  const showModal = useCallback(() => {
    setPayInvoiceModal(true)
    setInvoicePaymentMethod(paymentMethodsStore.paymentMethods[0] || {})
  }, [
    paymentMethodsStore.paymentMethods,
    setPayInvoiceModal,
    setInvoicePaymentMethod,
  ])

  if (
    !company ||
    !info ||
    loading ||
    fullInvoiceInfoLoading ||
    typeof isFactoring !== 'boolean'
  ) {
    return <Loading />
  }

  return (
    <Wrapper
      toolbar={<GroupedInvoicesHeader navigation={navigation} />}
      containerStyle={{ alignSelf: 'center' }}
    >
      <CompanyHeader
        company={company}
        totalAmount={totalInvoiceAmount}
        style={SharedStyles.payInvoiceHeader}
        amountLabel={t('TabInvoice.amount_due')}
      />

      <GroupedInvoiceList
        invoices={invoices}
        t={t}
        navigation={navigation}
        onSelect={onSelect}
      />

      {selectedInvoices.length === 0 ? (
        <BtText style={styles.selectAtleastOneText}>
          {t('InvoiceDetails.SelectAtLeastOneInvoice')}
        </BtText>
      ) : null}

      <BtText style={styles.chooseMethodText}>
        {t('InvoiceDetails.choose-method')}
      </BtText>

      {isInvoiceEligible &&
        !!ApplicationStore.paymentPlans.length &&
        !isFactoring && (
          <>
            <ApplyBTCreditItem
              loanAppDetails={loanAppDetails}
              amountLessThanMin={totalInvoiceAmount < Number(minBnplAmount)}
              onPress={() => {
                setBtcredit(true)
              }}
              navigation={navigation}
              setModal={setBtcredit}
              showInfo
              disabled={selectedInvoices.length === 0 || isBTCreditDisabled}
            />
            <Spacer height={23} />
            {!isBTCreditDisabled && !areRegularPaymentsDisabled && (
              <OrDivider />
            )}
          </>
        )}

      {!areRegularPaymentsDisabled &&
        acceptAchPayment &&
        !isBTCreditDisabled && (
          <>
            {achDiscountEligibility.all ? (
              <EligibleForACHdiscount
                label={t('InvoiceDetails.EligibleForACHdiscount')}
              />
            ) : achDiscountEligibility.some ? (
              <EligibleForACHdiscount
                label={t('InvoiceDetails.SomeEligibleForACHdiscount')}
              />
            ) : null}
          </>
        )}

      {!areRegularPaymentsDisabled && !isBTCreditDisabled && (
        <>
          {!(
            info?.isPaymentMethodsAdded ||
            paymentMethodsStore.paymentMethods.length
          ) ? (
            <AddPaymentMethodOptions
              navigation={navigation}
              id={incomeSelectedInvoices[0]?._id}
              getBankAccounts={getBankAccounts}
              canAddBankAccount={acceptAchPayment}
            />
          ) : (
            <>
              {paymentMethodsStore.paymentMethods
                .filter(
                  (acc) => acceptAchPayment || acc.paymentMethodType !== 'bank',
                )
                .map((acc: PaymentMethod, i) => (
                  <PaymentMethodItem
                    key={i}
                    item={acc}
                    onPaymentSelection={onPaymentSelection}
                    disabled={
                      selectedInvoices.length === 0 || totalInvoiceAmount <= 0
                    }
                  />
                ))}
              <AddNewButton />
            </>
          )}
        </>
      )}

      {!exists && (
        <Link
          title={t('InvoiceDetails.what-is-bt')}
          color={commonColors.accentText}
          textStyle={{ fontSize: 14 }}
          onPress={() => {
            setWhatIsModal(true)
          }}
        />
      )}

      {/* Option hidden until a supplier switch for this is developed
      <Link
        title={t('InvoiceDetails.i-dont-want-to-pay')}
        color="#DA515E"
        textStyle={{ fontSize: 14, marginVertical: 26 }}
        onPress={() => {
          setCancelModal(true)
        }}
      /> */}

      {/*  ====================================================== MODALS ========================================================  */}

      {!![
        dictionaries.LOAN_APPLICATION_STATUS.APPROVED,
        dictionaries.LOAN_APPLICATION_STATUS.PROCESSING,
        dictionaries.LOAN_APPLICATION_STATUS.CANCELED,
      ].find((s) => s === loanAppDetails?.status) && (
        <InvoiceCreditPaymentFlow
          invoices={selectedInvoices}
          onClose={() => setBtcredit(false)}
          navigation={navigation}
        />
      )}

      <InvoiceAlert
        visible={showInvoiceAlert}
        statusData={{
          invoiceStatus: selectedInvoices[0]?.status,
          cardPaymentAvailable,
        }}
        invoice={selectedInvoices[0]}
        customLabel={t('InvoiceDetails.ChoosePayment')}
        onClose={() => {
          setShowInvoiceAlert(false)
        }}
      />

      <BuilderInvoiceSignup
        invoice={selectedInvoices[0]}
        invoiceIds={selectedInvoices.map((inv) => inv?._id).filter(Boolean)}
        btcredit
        visible={btcredit}
        onClose={() => {
          setBtcredit(false)
        }}
        setLoading={setLoading}
        navigation={navigation}
        route={route}
        status={loanAppDetails?.status}
        selectedInvoices={selectedInvoices}
      />

      <ConfirmPrompt
        visible={cancelModal}
        icon={<IconInvoicePrompt />}
        onDismiss={() => {
          setCancelModal(false)
        }}
        title={t('DismissAlert.title')}
        message={t('DismissAlert.message')}
        firstButton={{
          title: 'Yes, dismiss',
          mode: 'contained',
          bgColor: '#E6F2FA',
          textColor: commonColors.accentText,
          onPress: () => {
            setCancelModal(false)
            if (RootStore.userStore.user) {
              setReasonModal(true)
            }
          },
        }}
        secondButton={{
          title: "I'll pay later",
          mode: 'contained',
          bgColor: commonColors.accentText,
          onPress: () => setCancelModal(false),
        }}
      />

      <ReasonModal
        modal={reasonModal}
        setModal={setReasonModal}
        invoices={selectedInvoices}
        navigation={navigation}
      />

      <WhatIsBTModal
        modal={whatIsModal}
        setModal={setWhatIsModal}
        setBtcredit={setBtcredit}
        isInvoiceEligible={isInvoiceEligible}
      />

      {!!Object.keys(invoicePaymentMethod).length && (
        <PayInvoiceModal
          modal={payInvoiceModal}
          setModal={() => {
            setPayInvoiceModal(false)
            setInvoicePaymentMethod({})
          }}
          paymentPlan={null}
          account={invoicePaymentMethod}
          navigation={navigation}
          showModal={showModal}
          invoices={selectedInvoices}
        />
      )}

      {!isMobile && (
        <BuilderBottomModal
          height={acceptAchPayment ? 300 : 200}
          visible={showAddPaymentMethod}
          onClose={() => setModal('')}
        >
          <AddPaymentMethodItems
            sourceInvoice={selectedInvoices[0]?._id}
            navigation={navigation}
            canAddBankAccount={acceptAchPayment}
            goToNextOnboardingPage={getBankAccounts}
            itemStyle={{ otherStyles: { title: { lineHeight: 24 } } }}
          />
        </BuilderBottomModal>
      )}

      <PaymentProcessingAlert navigation={navigation} />

      <UploadedInvoicePaymentSuccessAlert navigation={navigation} />

      <InvoicePaymentStatusModal
        invoice={selectedInvoices[0]}
        totalAmount={totalInvoiceAmount - totalACHDiscount}
      />

      <AddProjectSuccessModal
        navigation={navigation}
        companyName={company?.name}
      />
      <GroupedInvoicesProjectWarning selectedInvoices={selectedInvoices} />
      <SelectPurchaseType />
      <ConnectCreditApplicationBankWithPlaid
        recheckConditionsBeforeApplyingCredit={() => setBtcredit(true)}
      />
    </Wrapper>
  )
})

const styles = StyleSheet.create({
  chooseMethodText: {
    fontSize: 16,
    fontWeight: '600',
    marginTop: 16,
    marginBottom: 16,
    lineHeight: 21,
    alignSelf: 'center',
  },
  selectAtleastOneText: {
    color: '#DA515E',
    fontWeight: '500',
    marginTop: 16,
  },
})
